<div class="grid">
  @if (!paymentDetail.card) {
  <div class="col-12">
    <span class="section-title" translate>payment_detail_bank_transfer</span>
  </div>
  }
  @if (paymentDetail.card && paymentDetail.card.expiryDate && paymentDetail.card.cvv) {
  <div class="col-5">
    <label>{{ 'payment_detail_expires_label' | translate }}:</label><br>
    <span id="expiryDatefield" class="field-value sensitive-data">{{ paymentDetail.card.expiryDate }}</span>
  </div>
  }
  <!-- DATES -->
  <div class="col-7">
    <label>{{ 'payment_detail_charge_between_label' | translate }}:</label><br>
    @if (editMode) {
    <p-datepicker id="effectiveDateRangeSelector" selectionMode="range" (onClose)="dateRangeSelected(dateSelector)"
      dateFormat="{{getDateFormatForCalendar()}}" #dateSelector dateFormat="yy-mm-dd" [(ngModel)]="effectiveDateRange"
      appendTo="body" />
    } @else {
    @if (paymentDetail.effectiveMinDate && paymentDetail.effectiveMaxDate) {
    <span id="effectiveDateRange" class="field-value">
      {{ paymentDetail.effectiveMinDate | customFormatDate }} -
      {{ paymentDetail.effectiveMaxDate | customFormatDate }}
    </span>
    }
    }
  </div>
</div>

<div class="grid mt-6">
  <!-- CVV -->
  @if (paymentDetail.card && paymentDetail.card.expiryDate && paymentDetail.card.cvv) {
  <div class="col-5">
    <label>{{ 'payment_detail_cvv_label' | translate }}:</label><br>
    <span id="cvvField" class="field-value sensitive-data">{{ paymentDetail.card.cvv }}</span>
  </div>
  }
  <!-- SENDER -->
  @if (!paymentDetail.card) {
  <div class="col-5">
    <label>{{ 'payment_detail_payer_label' | translate }}:</label><br>
    <span class="field-value">{{ paymentDetail.senderName }}</span>
  </div>
  }
  <!-- AMOUNT -->
  <div class="col-7">
    <label>{{ 'payment_detail_amount_label' | translate }}:</label><br>
    @if (editMode) {
    <p-inputNumber id="amountInput" [(ngModel)]="paymentDetail.amount" mode="decimal" [minFractionDigits]="2"
      [maxFractionDigits]="2">
    </p-inputNumber>
    } @else {
    <span id="amount" class="field-value">{{ paymentDetail.currency }} {{ paymentDetail.amount! | customFormatNumber
      }}</span>
    }
  </div>
</div>